module.exports = __webpack_public_path__ + "img/xsty-xcb-icon-1@2x.253b7641.png";